const ja_JP = {
    info: {
        title: "あくあボタン",
        info: "通知",
        null: "空",
        audioStaff: "オーディオクリップ: mchong111 CatCoffee",
        toGithub: "Githubで翻訳に参加、音声を追加および提案をしてください。",
        notOfficial: "このサイトはファン作品であり、公式とは関係ありません。",
        overlapTips: "声重なる再生モードは手動で停止できません。大量のスレッドを作成するので、後リフレッシュしてください。"
    },
    action: {
        toggleNavbar: "ナビゲーションバーを切り替える",
        close: "閉じる",
        copy: "コピー",
        control: "コントロール",
        stopvoice: "再生停止",
        randomplay: "ランダム",
        overlap: "声重なる可能",
        autoplay: "とまらない",
        playing: "現在再生：",
        noplay: "再生なし"
    },
    lang: {
        'zh-CN': "简体中文",
        'en-US': "English",
        'ja-JP': "日本語"
    }
}
export default ja_JP;
